module.exports = __webpack_public_path__ + "img/img-a35d495b.dfbc8941.png";